export const RETURN_TO_FULL_DUTY_ID = 12;
export const INDEFINITE_RESTRICTIONS_ID = 11;
